<template>
  <div class="px-2 sm:px-0 w-full">
    <div class="flex w-full flex-col sm:flex-row sm:justify-between mb-3 sm:mb-5">
      <p class="self-start hidden sm:flex sm:self-center text-xl font-bold text-purple_dark">
        {{numbers.length}} Phone Number(s)
      </p>
      <div class="self-end">
        <button
                @click="addNumber()"
                class="sm:w-full flex bg-transparent bg-purple_dark sideBackground text-white font-semibold hover:text-white py-2 px-4 hover: rounded-lg">

          Add New Number
        </button>
      </div>
    </div>
    <div class="flex flex-wrap w-full">
      <div :key="number.key" class="w-full sm:w-1/2 md:w-1/3 lg:w-1/5  mb-3 sm:mb-6" v-for="number in numbers">
        <div class="rounded-lg shadow-lg bg-white sm:mr-4">
          <div class="w-full  p-3">
            <p class="text-2xl capitalize text-purple_dark font-medium">
              {{number.state}}
            </p>
            <p>
              Contact : {{number.number}}
            </p>
          </div>
          <div class="flex">
            <button
                    @click="editNumber(number)"
                    class="w-1/2 bg-blue text-white flex justify-center font-semibold hover:text-white py-2 px-4 hover: rounded-bl-lg">
              <Edit3Icon></Edit3Icon>
            </button>
            <button
                    @click="deleteNumber(number)"
                    class="w-1/2 bg-red-medium  flex justify-center text-white font-semibold hover:bg-red-dark py-2 px-4 hover: rounded-br-lg">
              <Trash2Icon></Trash2Icon>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {eventBus} from "../../eventbus";
  import {db} from "../../db";
  import { Trash2Icon,Edit3Icon } from 'vue-feather-icons'
  export default {
    name: "NumberContent",
    components:{
      Trash2Icon,Edit3Icon
    },
    props: {
      numbers: {
        type: Array
      },
      numberKeys: {
        type: Array
      }
    },
    methods: {
      addNumber() {
        eventBus.$emit('AddNumber')
      },
      editNumber(x) {
        eventBus.$emit('EditNumber', x)
      },
      // eslint-disable-next-line no-unused-vars
      deleteNumber(x) {
        this.$confirm(`Are you sure you want to delete ${x.state} - ${x.number}?`, '',
            "error")
            .then(() => {

              let number = this.numberKeys.find(item => item.number === x.number);
              db.ref('numbers/' + `${number.key}`).remove().then(() => {
                this.$toast.open({
                  message: 'Successful',
                  type: 'success'
                });
              })
            })
            .catch(() => {
            });

      }
    }
  }
</script>

<style scoped>

</style>
